<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraSolicitacao />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import LeituraSolicitacao from "../Components/Leituras/LeituraSolicitacao.vue";
export default {
  name: "ReadHotel",
  components: {
    LeituraSolicitacao,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>